import { type ReactNode } from "react";

interface ProofBadgeProps {
  /**
   * - filled  : preuve presente et valide (TSA, Merkle, ancrage SUCCESS).
   *             Gradient or chaud.
   * - muted   : preuve presente, contexte sobre (badge dans une liste).
   *             Or transparent + bordure douce.
   * - missing : preuve absente / brouillon. Pointille gris.
   */
  variant?: "filled" | "muted" | "missing";
  icon?: ReactNode;
  children: ReactNode;
  /** Tooltip natif (rendu via title attribute). */
  title?: string;
}

// Badge probatoire premium reutilisable. Consomme les classes
// .proof-badge / --muted / --missing declarees en Phase A index.css.
//
// Usage canonique :
//   <ProofBadge variant="filled" icon={<ShieldCheck size={11} />}>TSA</ProofBadge>
//   <ProofBadge variant="filled" icon={<Network size={11} />}>Merkle</ProofBadge>
//   <ProofBadge variant="filled" icon={<Anchor size={11} />}>Polygon</ProofBadge>
//   <ProofBadge variant="missing">Dépôt legacy</ProofBadge>
export function ProofBadge({
  variant = "filled",
  icon,
  children,
  title,
}: ProofBadgeProps) {
  const className =
    variant === "muted"
      ? "proof-badge proof-badge--muted"
      : variant === "missing"
        ? "proof-badge proof-badge--missing"
        : "proof-badge";
  return (
    <span className={className} title={title}>
      {icon && <span className="shrink-0 inline-flex">{icon}</span>}
      <span>{children}</span>
    </span>
  );
}
